<template>
  <div>
    <section class="event about bg bg-img bg-about bg-about-banner">
		<div class="container">
			<div class="row">
				<div class="col-md-10 offset-md-1">
					<div class="title title3">
						<div class="main-title">
							<h2 class=" text-white" style="font-family: 'kalpurush'">{{title}}</h2>
						</div>
						<!-- <div class="sub-title">
							<p class="text-white">{{subTitle}}</p>
						</div> -->
					</div>
				</div>
			</div>
		</div>
	</section>
  </div>
</template>
<script>
export default {
  name: 'Banner',
  props: ['title','subTitle'],
  data() {
    return {
    
    }
  },
  computed: {
    
  },
  methods: {
    
  }
}
</script>

<style>
@media only screen and (max-width: 1366px){
section, footer {
    padding: 55px 0;
}
}
.event p {
    font-size: calc(15px + (18 - 13) * ((100vw - 300px) / (1920 - 300)));
    /* margin-bottom: -10px;
    letter-spacing: 0.5px;
    font-weight: 400; */
}
.event h2 {
    font-size: calc(35px + (40 - 30) * ((100vw - 300px) / (1920 - 300)));
    /* margin-top: -2px;
    margin-bottom: -6px;
    letter-spacing: 1px;
    font-weight: 700;
    line-height: 1.4; */
}
.title{
    margin-bottom:0px;
}
.img-fluid {
  max-width: 100%;
}
</style>
